(function () {
  'use strict';

  /* Evita doble ejecucion si la pagina incluye el tag dos veces */
  if (window._kcControllerInit) return;
  window._kcControllerInit = true;

  /* ─── SWATCH / VARIANTE ────────────────────────────────────────────── */
  function initSwatch() {
    var swatchWrap = document.querySelector('.kc-diag-booster-swatches');
    if (!swatchWrap) return;

    var pid = swatchWrap.getAttribute('data-pid');
    if (!pid) return;

    function allCards() {
      return document.querySelectorAll('#kc-diag-' + pid + ' .kc-diag__card');
    }

    function treatmentFrom(val) {
      var v = (val || '').toLowerCase();
      return v.indexOf('keratina') > -1 ? 'keratina'
           : v.indexOf('cirug')    > -1 ? 'cirugia' : null;
    }

    function findSpan(val, idx) {
      var candidates = document.querySelectorAll('[data-swatch-index="' + idx + '"]');
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].getAttribute('data-swatch-option') === val) return candidates[i];
      }
      return null;
    }

    /* Cambia la imagen principal de la galería al thumbnail del tratamiento */
    function switchGallery(treatment) {
      function doSwitch() {
        var thumbs = document.querySelectorAll('span.gallery__thumbnail');
        for (var i = 0; i < thumbs.length; i++) {
          var img = thumbs[i].querySelector('img');
          if (!img) continue;
          var src = (
            img.getAttribute('data-src') ||
            img.getAttribute('data-original') ||
            img.src || ''
          ).toLowerCase();
          /* Buscar el thumbnail de combo específico para evitar coincidir
             con las fotos generales del producto (ej. keratina_epa_colombia_la_original_*.jpg) */
          var match = (treatment === 'keratina' && src.indexOf('keratina_capilar_epa_colombia_mini_combo') > -1) ||
                      (treatment === 'cirugia'  && src.indexOf('cirugia_capilar_epa_colombia_mini_combo') > -1);
          if (match) { thumbs[i].click(); return; }
        }
      }
      doSwitch();
      setTimeout(doSwitch, 500);
    }

    /* Unico actualizador: tarjetas + galeria + evento central */
    function updateAll(treatment) {
      document.documentElement.setAttribute('data-treatment', treatment);
      allCards().forEach(function (card) {
        var v = (card.getAttribute('data-diag-value') || '').toLowerCase();
        var m = (treatment === 'keratina' && v.indexOf('keratina') > -1) ||
                (treatment === 'cirugia'  && v.indexOf('cirug')    > -1);
        card.classList.toggle('is-selected', m);
      });
      switchGallery(treatment);
      window.dispatchEvent(new CustomEvent('kc:variant-changed', { detail: { treatment: treatment } }));
    }

    /* MutationObserver sobre TODO el body — cubre spans visibles y ocultos */
    var initDone = false; // bloquea reacción durante setup inicial de Booster
    var obs = new MutationObserver(function (muts) {
      if (!initDone) return;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName !== 'class') continue;
        var el = muts[i].target;
        if (!el.hasAttribute('data-swatch-option')) continue;
        if (!el.classList.contains('swatch--active')) continue;
        var t = treatmentFrom(el.getAttribute('data-swatch-option'));
        if (t) { updateAll(t); break; }
      }
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });

    /* Clic en tarjeta diagnostica */
    document.addEventListener('click', function (e) {
      var card = e.target.closest('#kc-diag-' + pid + ' .kc-diag__card');
      if (!card) return;
      var val = card.getAttribute('data-diag-value');
      var idx = card.getAttribute('data-diag-idx');
      var span = findSpan(val, idx);
      if (!span) return;

      allCards().forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');

      if (!span.classList.contains('swatch--active')) {
        span.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      } else {
        var t = treatmentFrom(val);
        if (t) window.dispatchEvent(new CustomEvent('kc:variant-changed', { detail: { treatment: t } }));
      }
    });

    /* API global para pestanas */
    window.kcActivateVariant = function (treatment) {
      var spans = document.querySelectorAll('[data-swatch-option]');
      for (var i = 0; i < spans.length; i++) {
        if (treatmentFrom(spans[i].getAttribute('data-swatch-option')) !== treatment) continue;
        if (spans[i].classList.contains('swatch--active')) {
          updateAll(treatment);
        } else {
          spans[i].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        }
        break;
      }
    };

    /* Permitir observer tras inicializacion de Booster y auto-seleccionar keratina */
    setTimeout(function () {
      initDone = true;
      var spans = document.querySelectorAll('[data-swatch-option]');
      for (var i = 0; i < spans.length; i++) {
        if (treatmentFrom(spans[i].getAttribute('data-swatch-option')) === 'keratina') {
          if (spans[i].classList.contains('swatch--active')) {
            updateAll('keratina');
          } else {
            spans[i].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          }
          break;
        }
      }
    }, 800);
  }

  /* ─── TABS TRATAMIENTO ──────────────────────────────────────────────── */
  function initTabs() {
    var wrap = document.querySelector('[id^="kc-tabs-"]');
    if (!wrap) return;

    var tabs = wrap.querySelectorAll('.kc-tabs__tab');
    var panels = wrap.querySelector('.kc-tabs__panels');

    function activateTab(treatment) {
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-tab') === treatment);
      });
      if (panels) panels.setAttribute('data-active', treatment);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var treatment = tab.getAttribute('data-tab');
        activateTab(treatment);
        if (typeof window.kcActivateVariant === 'function') {
          window.kcActivateVariant(treatment);
        }
      });
    });

    wrap.querySelectorAll('.kc-block-faq__q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.closest('.kc-block-faq').classList.toggle('is-open');
      });
    });

    window.addEventListener('kc:variant-changed', function (e) {
      if (e.detail && e.detail.treatment) activateTab(e.detail.treatment);
    });
  }

  /* ─── ATC GUARD ─────────────────────────────────────────────────────── */
  function initATCGuard() {
    return; // deshabilitado: botones siempre habilitados
    var unlocked = false;

    /* Mensaje de guía */
    var hint = document.createElement('p');
    hint.textContent = '👆 Elige tu tratamiento antes de continuar';
    hint.style.cssText = 'display:none;color:#ff66c4;font-size:12px;font-weight:700;text-align:center;margin:8px 0 0;';
    var mainForm = document.querySelector('form[action*="/cart/add"]');
    var mainBtn  = mainForm ? mainForm.querySelector('[name="add"]') : null;
    if (mainBtn) mainBtn.insertAdjacentElement('afterend', hint);

    function showHint() {
      hint.style.display = 'block';
      var diag = document.querySelector('.kc-diag');
      if (diag) diag.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* Bloquear TODOS los botones [name="add"] (principal + sticky) */
    function lockAll() {
      document.querySelectorAll('[name="add"]').forEach(function (btn) {
        btn.disabled = true;
        btn.style.opacity = '0.4';
        btn.style.cursor  = 'not-allowed';
      });
      var pay = document.querySelector('.shopify-payment-button');
      if (pay) { pay.style.opacity = '0.4'; pay.style.pointerEvents = 'none'; }
    }

    function unlockAll() {
      unlocked = true;
      document.querySelectorAll('[name="add"]').forEach(function (btn) {
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.cursor  = '';
      });
      hint.style.display = 'none';
      var pay = document.querySelector('.shopify-payment-button');
      if (pay) { pay.style.opacity = ''; pay.style.pointerEvents = ''; }
    }

    /* MutationObserver: re-bloquea si Booster re-habilita el botón */
    var mo = new MutationObserver(function () { if (!unlocked) lockAll(); });
    function observeBtn(btn) {
      mo.observe(btn, { attributes: true, attributeFilter: ['disabled', 'class', 'style'] });
    }
    if (mainBtn) observeBtn(mainBtn);

    /* Intercepción global capture-phase: cubre sticky ATC y cualquier trigger */
    document.addEventListener('click', function (e) {
      if (unlocked) return;
      if (!e.target.closest('[name="add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showHint();
    }, true);

    document.addEventListener('submit', function (e) {
      if (unlocked) return;
      var a = e.target.action || '';
      if (a.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showHint();
    }, true);

    /* Aplicar bloqueo inicial y tras carga de elementos dinámicos */
    lockAll();
    setTimeout(lockAll, 600);
    setTimeout(function () {
      lockAll();
      /* Observar sticky ATC si aparece después */
      document.querySelectorAll('[name="add"]').forEach(function (btn) {
        if (!btn.closest('form[action*="/cart/add"]')) observeBtn(btn);
      });
    }, 1400);

    window.addEventListener('kc:variant-changed', unlockAll);
  }

  /* ─── REVIEW LABEL ──────────────────────────────────────────────────── */
  function initReviewLabel() {
    function buildLabel() {
      var el = document.createElement('div');
      el.className = 'kc-reviews-label';
      el.textContent = '4.8/5  Reseñas verificadas  —  +32.600 Vendidos';
      el.style.cssText = 'font-size:12px;font-weight:600;color:#666;margin:2px 0 4px;line-height:1.4;';
      return el;
    }

    function inject() {
      if (document.querySelector('.kc-reviews-label')) return;

      /* Las estrellas (Seal Reviews) se inyectan ANTES del precio.
         Insertamos ANTES del precio → quedamos justo debajo de las estrellas. */
      var priceHolder = document.querySelector('[class*="product__price--holder"]');
      if (priceHolder) {
        priceHolder.insertAdjacentElement('beforebegin', buildLabel());
        return;
      }

      /* Fallback: después del título */
      var title = document.querySelector('.product__title');
      if (title) {
        title.insertAdjacentElement('afterend', buildLabel());
      }
    }

    var obs = new MutationObserver(function () { inject(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 6000);

    setTimeout(inject, 300);
    setTimeout(inject, 800);
  }

  /* ─── INIT ──────────────────────────────────────────────────────────── */
  function init() {
    initSwatch();
    initTabs();
    initATCGuard();
    initReviewLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
